var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gotop-button",attrs:{"title":_vm.$gettext('Back to the top')},on:{"click":_vm.onClick}},[_c('fa-icon',{attrs:{"icon":"arrow-up"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }